<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
import common from './utils/common.utils.js'

export default {
  name: 'App',
  components: {},
  data: function () {
    return {
      showHeight: document.documentElement.clientHeight, // 实时屏幕高度
      timeout: false,
      max: 1
    }
  },
  methods: {
    // 高度获取
    getHeight: function () {
      var app = document.getElementById('app')
      var height =
        document.documentElement.clientHeight + common.getScrollHeight().top
      // console.log(scrollHeight());
      // app.style.cssText =
      //   "height:" + height + "px;" + "background-color:rgb(246, 246, 246);";
      // app.style.cssText =
      //   "height:" + height + "px;" + "background-color:#f0f2f5;";
      app.style.cssText = 'height:' + height + 'px;'
    },
    // 判断是pc mobile
    _isMobile: function () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },

    // rem
    fnResize: function () {
      var docEl = document.documentElement

      // var deviceWidth =
      //   document.documentElement.clientWidth || window.innerWidth;
      // console.log(deviceWidth);
      let maxWidth = 750
      let cw = docEl.clientWidth > maxWidth ? maxWidth : docEl.clientWidth
      // if (deviceWidth >= 750) {
      //   deviceWidth = 750;
      // }
      // if (deviceWidth <= 320) {
      //   deviceWidth = 320;
      // }
      document.documentElement.style.fontSize = 10 * (cw / 320) + 'px'
      console.log('font-size:', docEl.style.fontSize)
    },
    // 公告

    getOnlineNotice: async function () {
      var res = await this.$http.get('/v1/notice/getOnlineNotice')
      var { code, data, message } = res.data
      if (code == 0) {
        clearTimeout(end)

        this.$store.state.noticeArray = data
        // console.log(data)
        var end = setTimeout(() => {
          this.getOnlineNotice()
        }, 10000)
      }
    }
  },
  computed: {},
  created: function () {
    // 刷新保存store中的数据
    var that = this
    if (localStorage.getItem('store')) {
      that.$store.replaceState(
        Object.assign(
          {},
          that.$store.state,
          JSON.parse(localStorage.getItem('store'))
        )
      )
    }
    window.addEventListener('beforeunload', function () {
      localStorage.setItem('store', JSON.stringify(that.$store.state))
    })
    // rem
    if (this._isMobile()) {
      this.fnResize()
      window.onresize = function () {
        this.fnResize()
      }
    }
  },
  mounted: function () {
    this.getHeight()
    window.addEventListener('scroll', this.getHeight, true)
    document.querySelector('#app').scrollIntoView(true)

    // 去除页面按空格键下移
    document.body.onkeydown = function (event) {
      // var keycode = event.keyCode || event.which
      // var e = window.event || event
      /* switch (keycode) {
        case 32:
          window.event.returnValue = false
          break
      } */
      // if (e.preventDefault) {
      //   e.preventDefault()
      // } else {
      //   window.event.returnValue = false
      // }
    }
    // 公告
  },
  watch: {
    // "$store.state.noticeArray": {
    //   handler: function(newValue, oldValue) {
    //     console.log("旧的公告列表", oldValue);
    //     console.log("公告更新", newValue);
    //   },
    //   deep: true
    // }
  }
}
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  background-color: #f0f2f5;
  color: #2c3e50;
  // min-width: 1200px;
  // margin-top: 60px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue